import gql from "graphql-tag";

export const activateMembershipFromInvitationCode = gql`
  mutation ActivateMembershipFromInvitationCode($input: ActivateMembershipFromInvitationCodeRequestInput) {
    ActivateMembershipFromInvitationCode(input: $input) {
      success
    }
  }
`;
